import React, { useState } from 'react';
import { 
  Typography, 
  Box, 
  Paper,
  Tabs,
  Tab
} from '@mui/material';
import ProjectsTab from './ProjectsTab';
import ExecutionsTab from './ExecutionsTab';
import ReportsTab from './ReportsTab';
import TrendsTab from './TrendsTab';

/**
 * PerformanceView component for managing performance testing projects and executions
 * @returns {JSX.Element} PerformanceView component
 */
const PerformanceView = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [selectedExecutionId, setSelectedExecutionId] = useState(null);
  const [selectedProjectId, setSelectedProjectId] = useState(null);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleViewExecution = (executionId) => {
    setSelectedExecutionId(executionId);
    setActiveTab(2); // Switch to Reports tab (index 2)
  };

  const handleViewProjectExecutions = (projectId) => {
    setSelectedProjectId(projectId);
    setActiveTab(1); // Switch to Executions tab (index 1)
  };
  
  return (
    <Box sx={{ width: '100%', maxWidth: '100%' }}>
      <Box mb={3}>
        <Typography variant="h4" gutterBottom>
          Performance Testing
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Manage performance testing projects, executions, and analyze JMeter results
        </Typography>
      </Box>
      
      <Paper elevation={2} sx={{ width: '100%', maxWidth: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="fullWidth"
          >
            <Tab label="Projects" />
            <Tab label="Executions" />
            <Tab label="Reports" />
            <Tab label="Trends" />
          </Tabs>
        </Box>
        
        <Box sx={{ p: 3 }}>
          {activeTab === 0 && <ProjectsTab onViewProjectExecutions={handleViewProjectExecutions} />}
          {activeTab === 1 && <ExecutionsTab onViewExecution={handleViewExecution} selectedProjectId={selectedProjectId} />}
          {activeTab === 2 && <ReportsTab selectedExecutionId={selectedExecutionId} />}
          {activeTab === 3 && <TrendsTab />}
        </Box>
      </Paper>
    </Box>
  );
};

export default PerformanceView;
